export default "__VITE_PUBLIC_ASSET__0291a397__"